import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

import { formatTonne } from '../../../shared/utils/number';

export default function ChartTooltip({ active, label, payload, totalLabel }) {
  if (!active || !payload?.length) return null;

  const entries = payload.filter((entry) => Number.isFinite(Number(entry.value)));
  const total = entries.reduce((sum, entry) => sum + Number(entry.value), 0);

  return (
    <Paper elevation={3} sx={{ minWidth: 190, p: 1.5 }}>
      <Typography variant="caption" sx={{ display: 'block', fontWeight: 800, mb: 1 }}>
        {label}
      </Typography>
      <Stack spacing={0.75}>
        {entries.map((entry) => (
          <Stack key={entry.dataKey} direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
            <Stack direction="row" alignItems="center" spacing={0.75}>
              <Box sx={{ bgcolor: entry.color, borderRadius: '2px', height: 8, width: 8 }} />
              <Typography variant="caption" color="text.secondary">{entry.name}</Typography>
            </Stack>
            <Typography variant="caption" sx={{ fontVariantNumeric: 'tabular-nums', fontWeight: 700 }}>
              {formatTonne(entry.value)}
            </Typography>
          </Stack>
        ))}
        {entries.length > 1 && (
          <Stack
            direction="row"
            justifyContent="space-between"
            spacing={2}
            sx={{ borderTop: 1, borderColor: 'divider', pt: 0.75 }}
          >
            <Typography variant="caption" sx={{ fontWeight: 700 }}>{totalLabel}</Typography>
            <Typography variant="caption" sx={{ fontVariantNumeric: 'tabular-nums', fontWeight: 800 }}>
              {formatTonne(total)}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Paper>
  );
}